import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import shirt from "./../../assets/images/shite-shirt.svg";
import { useNavigate } from "react-router-dom";
const About = () => {
  let navigate = useNavigate();
  return (
    <>
      <Box
        className="about-us-section"
        pt={"50px"}
        component={"div"}
        id="aboutSection"
        sx={{ backgroundColor: "blue.secondary" }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h3"
            fontWeight={"bold"}
            color={"ButtonHighlight"}
          >
            About Us
          </Typography>
        </Box>
        <Grid container className="about-us-main">
          <Grid item md={6} xs={12} className="about-us-content">
            <Box>
              <Box
                className="about-us-subheading"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: { md: "start", sm: "center" },
                }}
              >
                <Typography
                  sx={{
                    color: "#ffff",
                    textAlign: { md: "start", xs: "center" },
                  }}
                  noWrap
                  className="heading"
                >
                  T-SHIRT AI
                </Typography>
                <Typography
                  sx={{
                    color: "yellow.light",
                    textAlign: { md: "start", xs: "center" },
                  }}
                  className="heading"
                >
                  DESIGNS
                </Typography>
              </Box>

              <Typography
                color={"white.main"}
                sx={{ textAlign: { md: "start", xs: "center" } }}
              >
                Lorem ipsum dolor sit amet consectetur. Malesuada nibh massa
                dignissim eu. Felis metus natoque at molestie a. Amet eget
                lobortis praesent congue etiam lobortis feugiat quis.
              </Typography>
              <Box className="about-generate-design">
                <Button
                  onClick={() => navigate("/generate")}
                  variant="contained"
                  sx={{
                    backgroundColor: "yellow.light",
                    color: "blue.main",
                    fontWeight: "bold",
                    marginTop: "3%",
                    "&:hover": {
                      color: "yellow.light",
                      background: "blue.main",
                    },
                  }}
                >
                  GENERATE YOUR DESIGN
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            className="about-us-image"
            sx={{ marginTop: { md: "0px", xs: "50px" } }}
          >
            <Box className="about-us-image">
              <img src={shirt} alt="" />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default About;
